import getSelectedFolderViewState from '../selectors/getSelectedFolderViewState';
import { clickTodo, updateIsEditing, enterTodo } from '../actions/todoListItemViewStateActions';
import { clickEditTodoContextMenuItem } from '../actions/todoContextMenuActions';
import { mutator } from 'satcheljs';

export const clickTodoMutator = mutator(clickTodo, actionMessage => {
    setCurrentEditTodoId(actionMessage.itemId);
});

export const enterTodoMutator = mutator(enterTodo, () => {
    clearCurrentEditTodoId();
});

export const clickEditTodoContextMenuItemMutator = mutator(
    clickEditTodoContextMenuItem,
    actionMessage => {
        setCurrentEditTodoId(actionMessage.itemId);
    }
);

export const updateIsEditingMutator = mutator(updateIsEditing, actionMessage => {
    if (!actionMessage.isEditing) {
        clearCurrentEditTodoId();
    } else {
        setCurrentEditTodoId(actionMessage.itemId);
    }
});

function setCurrentEditTodoId(todoId: string) {
    const viewState = getSelectedFolderViewState();
    viewState.currentEditingTodoId = todoId;
}

function clearCurrentEditTodoId() {
    const viewState = getSelectedFolderViewState();
    viewState.currentEditingTodoId = '';
}
